import React, { Component } from 'react';
import Main from './components/Main/Main';
import './App.css';
import RampThemes from './components/Themes/RampThemes'
import Backend from './api/Backend'

class App extends Component {

	goTo(route) {
		this.props.history.replace(`/${route}`)
	}

	// login = () => {
	// 	this.props.auth.login();
	// }

	// logout = () => {
	// 	this.props.auth.logout();
	// }

	// componentDidMount() {
	// 	const { renewSession } = this.props.auth;

	// 	if (localStorage.getItem('isLoggedIn') === 'true') {
	// 		renewSession();
	// 	} else {
	// 		this.props.auth.login();
	// 	}

	// }

	render() {
		//const { isAuthenticated } = this.props.auth;
		let curRoute = this.props.location.pathname;

		if (curRoute === "/lite_toggle") {
			RampThemes.SetLiteMode(true);
			Backend.raiseRamp1();
		} else if (curRoute === "/lite") {
			RampThemes.SetLiteMode(true);
		} else {
			RampThemes.SetLiteMode(false);
		}

		// TODO: Use routes to handle this
		if (curRoute === "/darkmode" || RampThemes.PrefersDarkMode()) {
			RampThemes.SetDarkMode(true);
		} else if (curRoute === "/lightmode" || RampThemes.PrefersLightMode()) {
			RampThemes.SetDarkMode(false);
		}

		return (
			//isAuthenticated() ? <Main auth={this.props.auth} {...this.props} /> : null
			<Main {...this.props} />
		);
	}
}

export default App;
